function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import "./sectionSubtitle.css";
const SectionSubtitle = ({
  classPrepend = "styled",
  className = "",
  titlePosition = "left",
  // "left", "center", "right"
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `${classPrepend}-section-subtitle ${className}`,
    style: {
      textAlign: titlePosition
    }
  }, rest), children);
};
export { SectionSubtitle };